module.exports = __webpack_public_path__ + "static/media/drone.051db609.svg";